import React, { useEffect, useState } from "react";
import { Route, Switch } from "react-router";

import {
  FiltrosHistorial,
  HistorialConFiltroProps,
} from "src/utils/interfaces";

import Menu from "src/components/Menu";

import HistorialDeTrabajoFiltros from "src/pages/HistorialDeTrabajoFiltros";
import HistorialDeTrabajo from "src/pages/HistorialDeTrabajo";

const HistorialConFiltro: React.FC<HistorialConFiltroProps> = (
  props: HistorialConFiltroProps
) => {
  const [filtros, setFiltros] = useState<FiltrosHistorial>({});

  useEffect(() => {
    const url = new URL(window.location.toString());
    const params = new URLSearchParams(url.search);

    const nombre = params.get("nombre_ps");
    const codigo = params.get("codigo_ps");
    const fechaInicio = params.get("fecha_desde");
    const fechaFin = params.get("fecha_hasta");
    const soloProcesadas = params.get("solo_procesadas");
    const soloSinProcesar = params.get("solo_sin_procesar");

    const ps = nombre && codigo ? { nombre, codigo } : undefined;

    setFiltros({
      puntoDeServicio: ps,
      fechaInicio: fechaInicio ? new Date(fechaInicio) : undefined,
      fechaFin: fechaFin ? new Date(fechaFin) : undefined,
      soloHorasProcesadas: !!soloProcesadas,
      soloHorasSinProcesar: !!soloSinProcesar,
    });
  }, []);

  const handleFiltrosChange = (filtros: FiltrosHistorial) => {
    setFiltros(filtros);
  };

  return (
    <Switch>
      <Route exact path="/historial-de-trabajo/filtros">
        <HistorialDeTrabajoFiltros
          filtros={filtros}
          handleFiltrosChange={handleFiltrosChange}
        />
      </Route>

      <Route path="/historial-de-trabajo">
        <Menu
          contentId="historial-de-trabajo"
          cerrarSesion={props.cerrarSesion}
          user={props.user}
          cargo={props.cargo}
        />

        <HistorialDeTrabajo cargo={props.cargo} filtros={filtros} />
      </Route>
    </Switch>
  );
};

export default HistorialConFiltro;
